<template>
  <base-dialog v-model="dialog" scrim="white" :persistent="true" @close="closeDialog">
    <template v-slot:title>
      <v-icon icon="mdi-shield-account" color="primary"></v-icon>
      {{ $t('moderator.dialog.title') }}
    </template>

    <template v-slot:content>
      <kicklet-loading v-if="loading"/>
      <div v-else>
        <div class="text-center">
          <v-row
              v-for="(el, i) in $tm(['verify.dialog.modList'])"
              :key="i"
              no-gutters
              class="mb-2 description-row"
          >
            <v-col sm="auto" class="mr-2 color-primary number-col">
              {{ i + 1 }}.
            </v-col>
            <v-col class="text-start">
              <span v-html="$rt(el)"></span>
            </v-col>
          </v-row>
          <copy-text-field :input="'/mod Kicklet'" label="Command" class="mt-3"/>
        </div>
        <v-alert v-if="error" :text="$t('verify.dialog.no-mod')" type="warning" color="error" density="compact" class="mt-5" />
      </div>
    </template>

    <template v-slot:actions>
      <kicklet-button color="secondary" :text="$t('dialog.logout')" @click="logout"/>
      <kicklet-button :disabled="loading || error" :text="$t('dialog.ok')" @click="closeDialog"/>
    </template>
  </base-dialog>
</template>

<script setup>
import { computed, ref } from 'vue';
import BaseDialog from '@/components/dialog/BaseDialog';
import KickletButton from '@/components/custom/kicklet/KickletButton.vue';
import CopyTextField from '@/components/custom/CopyTextField.vue';
import { useStore } from 'vuex';
import { Kick } from '@/services/Kick';
import KickletLoading from '@/components/custom/kicklet/KickletLoading.vue';
import { Backend } from '@/services/Backend';
import { useRouter } from 'vue-router';

const props = defineProps({
  modelValue: Boolean,
});

const emit = defineEmits(['update:modelValue']);

const dialog = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
});

const store = useStore();
const router = useRouter();
const loading = ref(false);
const error = ref(false);

async function closeDialog () {
  try {
    dialog.value = true;
    loading.value = true;
    const isMod = await Kick.isModerator(store.getters.kickUsername);
    if (isMod) {
      dialog.value = false;
      Backend.reloadConnections();
    } else {
      error.value = true;
      loading.value = false;
      setTimeout(() => {
        error.value = false;
      }, 3000);
    }
  } catch (e) {
  }
}

async function logout () {
  await Backend.logout();
  await router.push('/');
  dialog.value = false;
}

</script>

<style scoped>
.description-row {
  font-size: 14px;
}

.number-col {
  max-width: 16px;
}
</style>
